
/* eslint-disable */
function init() {

	$("#header-promo-banner").slick({
		autoplay: true,
		autoplaySpeed: 5000,
	});
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./cartridges/app_puntroma_core/cartridge/js/pages/checkout/checkout.js